export const APPLY_FILTER_SUCCESS = 'APPLY_FILTER_SUCCESS';
export const APPLY_FILTER_FAIL = 'APPLY_FILTER_FAIL';

export const CLEAR_FILTER_SUCCESS = 'CLEAR_FILTER_SUCCESS';
export const CLEAR_FILTER_FAIL = 'CLEAR_FILTER_FAIL';

export const REMOVE_FILTER_SUCCESS = 'REMOVE_FILTER_SUCCESS';
export const REMOVE_FILTER_FAIL = 'REMOVE_FILTER_FAIL';
